export const API_URL = 'https://sangkien.fpt.com.vn/backend/api/v1.0';
export const CLIENT_URL = 'https://sangkien.fpt.com.vn';
// export const CLIENT_URL = 'https://fi20-dev.fsoft.com.vn/sku-new';
export const PROCESS_LOGIN_PAGE = 'https://sangkien.fpt.com.vn/';
//export const LOGIN_URL = `https://adfs.fpt.com.vn/adfs/oauth2/authorize?client_id=FSOFT-SKU-UAT&response_type=code&response_mode=query&redirect_uri=${PROCESS_LOGIN_PAGE}&prompt=login`;
export const LOGIN_URL = `https://login.microsoftonline.com/f01e930a-b52e-42b1-b70f-a8882b5d043b/oauth2/authorize?client_id=a5c6c573-f94b-4204-8dbb-49ba8bd8810d&response_type=code&redirect_uri=${PROCESS_LOGIN_PAGE}&response_mode=query&sso_reload=true`;
export const DEFAULT_PAGE_START = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_COMBOBOX_PAGE_SIZE = 10;
export const COMBOBOX_MIN_CHAR_TO_SEARCH = 1;
export const COOKIES_EXPIRED_TIME = 365 * 24 * 60 * 60;
//export const LOGOUT_URL = 'https://adfs.fpt.com.vn/adfs/oauth2/logout'; //for adfs
export const LOGOUT_URL = `https://login.microsoftonline.com/fptcloud.onmicrosoft.com/oauth2/logout?post_logout_redirect_uri=${PROCESS_LOGIN_PAGE}`; //azure
export const SYSTEM_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  BOV: 'bov',
  REVIEWER: 'reviewer'
};
export const SCREEN_CODE = {
  REVIEW_SUBMISSION: 'REVIEW_SUBMISSION',
  MASTER_DATA: 'MASTER_DATA',
  ROLE_MANAGER: 'ROLE_MANAGER',
  CTTV_MANAGER: 'CTTV_MANAGER',
  USER_PROFILE: 'USER_PROFILE',
  MY_SUBMISSION: 'MY_SUBMISSION',
  IP_VIEW_ADMIN: 'IP_VIEW_ADMIN',
  BANNER_MANAGER: 'BANNER_MANAGER',
  FILE_MANAGER: 'FILE_MANAGER',
  MAIL_TEMPLATE_MANAGER: 'MAIL_TEMPLATE_MANAGER',
  LOG_ACTIVITY: 'LOG_ACTIVITY',
  REPORT: 'REPORT',
  IDEA_CONTEST: 'IDEA_CONTEST',
  IDEA_EXAMINATION: 'IDEA_EXAMINATION',
  IDEA_RECOGNITION: 'IDEA_RECOGNITION',
  FINAL_FOLDER: 'FINAL_FOLDER'
};
export const PERMISSION_SCREEN_MAP = {
  ReviewSubmission: 'REVIEW_SUBMISSION',
  MasterData: 'MASTER_DATA',
  AccountManager: 'ACCOUNT_MANAGER',
  RolesManager: 'ROLE_MANAGER',
  CTTVManager: 'CTTV_MANAGER',
  IPViewAdmin: 'IP_VIEW_ADMIN',
  ManageBanner: 'BANNER_MANAGER',
  ManageFile: 'FILE_MANAGER',
  MailTemplate: 'MAIL_TEMPLATE_MANAGER',
  Headlines: 'REPORT',
  IdeasContest: 'IDEA_CONTEST',
  IdeasExamination: 'IDEA_EXAMINATION',
  IdeasRecognition: 'IDEA_RECOGNITION',
  FinalFolder: 'FINAL_FOLDER'
};
export const ROLE_TYPE = {
  ADMIN: 'admin',
  USER: 'user'
};



// WEBPACK FOOTER //
// ./src/config/index.js